import { api } from '../../api'
import { AddToSystem, type AddToSystemProps } from '../AddToSystem/AddToSystem'
import { LibSelect } from './LibSelect'

export function QualificationSelect(props: AddToSystemProps) {
	const { data: contact, isSuccess } = api.useContactByLinkedInIdQuery(
		props.entityId ?? '',
		{
			skip: !props.entityId
		}
	)

	if (isSuccess && contact) {
		const selectProps = {
			...props,
			contactId: contact.id
		}

		return (
			<LibSelect {...selectProps} />
		)
	}

	return <AddToSystem {...props} />
}
